import {z} from "zod";
import {imageSchema} from "@/images/ImageSchema.ts";

export const campaignSchema = z.object({
    id: z.uuid(),
    slug: z.string().trim().min(1, "Slug erforderlich")
        .max(120, "Slug darf höchstens 120 Zeichen haben")
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Nur Kleinbuchstaben, Zahlen und Bindestriche erlaubt"),
    title: z.string().trim().min(1, "Titel erforderlich"),
    description: z.string(),
    image: imageSchema.nullish().refine(value => value != null, "Kampagnenbild erforderlich"),
});

export function slugFromTitle(title: string): string {
    return title.toLocaleLowerCase("de-DE")
        .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
        .slice(0, 110).replace(/-$/g, "");
}

export type CampaignFormInput = z.input<typeof campaignSchema>;
export type CampaignFormOutput = z.output<typeof campaignSchema>;
